export default __webpack_public_path__ + "/dist/images/recipeactive.abf822ebf2238ea10becf6bdb428f178.svg";